module.exports = __webpack_public_path__ + "img/alipay.4d10b8cb.png";